import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  ClusterSchema,
  LayoutSchema,
  MaterialLayoutSchema,
  ProcessStepSchema,
  QuoteRequestLineSchema,
} from "../types";

const c = initContract();

export const clusterContract = c.router({
  findOne: {
    method: "GET",
    path: "/cluster/:id",
    responses: {
      200: ClusterSchema.extend({
        excludedProcessSteps: ProcessStepSchema.array(),
        sourceQuoteRequestLine: QuoteRequestLineSchema,
        targetQuoteRequestLines: QuoteRequestLineSchema.array(),
      }),
    },
  },
  update: {
    method: "PATCH",
    path: "/cluster/update/:id",
    body: z.object({
      cluster: z.string().uuid().array(),
    }),
    responses: {
      200: QuoteRequestLineSchema.merge(
        z.object({
          layout: LayoutSchema.merge(
            z.object({
              materialLayout: MaterialLayoutSchema.nullable(),
            }),
          ).nullable(),
        }),
      ),
    },
  },

  updateExcludedProcessSteps: {
    method: "PATCH",
    path: "/cluster/:id",
    body: z.object({
      excludedProcessSteps: z.string().uuid().array().optional(),
    }),
    responses: {
      200: ClusterSchema.extend({
        excludedProcessSteps: ProcessStepSchema.array(),
        sourceQuoteRequestLine: QuoteRequestLineSchema,
        targetQuoteRequestLines: QuoteRequestLineSchema.array(),
      }),
    },
  },
});
